module.exports = __webpack_public_path__ + "static/media/icon.3848566e.svg";